const fr = {
  'translation': {
    '404Content': 'Nous sommes désolés mais la page que vous recherchez n\'existe pas.',
    '404Title': '404 - Page non trouvée',
    'alertFeed': 'Flux d\'alertes',
    'allRightsReserved': 'Tous droits réservés.',
    'automatedCalls': 'Appels automatisés',
    'byWhatMeansOfCommunicationWouldYouLikeToBeReached': 'Par quel moyen de communication désirez-vous être rejoint?',
    'cancel': 'Annuler',
    'carecityAlertSubscriptionForm': 'Formulaire d\'inscription aux alertes Carecity',
    'carecityAlertUnsubscriptionForm': 'Formulaire de désinscription aux alertes Carecity',
    'carecityio': 'https://carecity.io',
    'carecitySmsAndAutomatedCallsAlertSystem': 'Système d\'alertes SMS et appels automatisés Carecity',
    'chooseYourCarecityCity': 'Choississez votre ville Carecity',
    'cityNotFound': 'Cette ville n\'existe pas.',
    'confirm': 'Confirmer',
    'confirmationNumber': 'Numéro de confirmation',
    'confirmationOfYourSubscription': 'Confirmation de votre inscription',
    'confirmationOfYourUnsubscription': 'Confirmation de votre désinscription',
    'confirmMySubscription': 'Valider mon inscription',
    'confirmMyUnsubscription': 'Valider ma désinscription',
    'consent': 'En cochant cette case, j\'accepte de recevoir des communications de Carecity à ce numéro de téléphone. Des frais de message et de données peuvent s\'appliquer. Envoyez STOP pour vous désabonner des messages à tout moment ou rendez-vous dans la section de désinscription de cette page.',
    'credentialsMissing': 'Aucun message ne peut être envoyé par cette ville.',
    'enterYourAddress': 'Entrez votre adresse',
    'enterYourConfirmationNumber': 'Entrez votre numéro de confirmation',
    'enterYourFullName': 'Entrez votre nom complet',
    'errorDuringSubscription': 'Erreur lors de l\'inscription',
    'errorDuringUnsubscription': 'Erreur lors de la désinscription',
    'errorOnServer': 'Une erreur est survenue lors du traitement de la demande.',
    'errorYouMustEnterYour6DigitConfirmationCode': 'Erreur, vous devez entrer votre code de confirmation à 6 chiffres.',
    'fromWhatMeansOfCommunicationWouldYouLikeToUnsubscribe': 'De quel moyen de communication désirez-vous vous désabonner?',
    'fullName': 'Nom complet',
    'iWouldLikeToUnsubscribeFromTheCarecityAlertServiceImmediately': 'Je désire me désinscrire du service d\'alertes Carecity immédiatement',
    'moreDetails': 'Plus de détails',
    'next': 'Suivant',
    'pendingSubscriptionNotFound': 'Le numéro de confirmation est invalide.',
    'pendingUnsubscriptionNotFound': 'Le numéro de confirmation est invalide.',
    'phoneNumber': 'Numéro de téléphone',
    'phoneNumberNotValid': 'Numéro de téléphone invalide.',
    'pleaseEnterYour6DigitConfirmationNumber': 'Veuillez renseigner votre numéro de confirmation à 6 chiffres.',
    'pleaseEnterYourAddress': 'Veuillez renseigner votre adresse.',
    'pleaseEnterYourCity': 'Veuillez renseigner votre ville.',
    'pleaseEnterYourConsent': 'Veuillez lire et cocher votre consentement à recevoir des communications de la part de la ville sélectionnée.',
    'pleaseEnterYourFullName': 'Veuillez renseigner votre nom complet.',
    'pleaseEnterYourMeansOfReceivingAlerts': 'Veuillez renseigner votre moyen de réception des alertes.',
    'pleaseEnterYourPhoneNumberInTheFollowingFormat': 'Veuillez renseigner votre numéro de téléphone avec le format suivant: +1 (123) 456-7891.',
    'previous': 'Précédent',
    'smsAlerts': 'Alertes SMS',
    'smsCredentialsMissing': 'Aucun SMS ne peut être envoyé par cette ville.',
    'subscribe': 'S\'abonner',
    'subscriberFound': 'Cet abonnement existe déjà.',
    'subscriberNotFound': 'Cet abonnement n\'existe pas.',
    'subscriptionCompletedSuccessfully': 'Inscription terminée avec succès!',
    'subscriptionDescription': 'Ce service permet la diffusion de messages aux citoyens pour signaler, par exemple, un avis d\'ébullition d\'eau, une évacuation, des travaux importants, un bris d\'aqueduc ou encore la fermeture de certaines rues.',
    'subscriptionTypeNotAvailableForCity': 'Cette ville ne supporte pas ce type d\'abonnement.',
    'tooManyFailedSubscriptionAttempts': 'Trop d\'essaies ont été fait pour valider cet abonnement.',
    'tooManyFailedUnsubscriptionAttempts': 'Trop d\'essaies ont été fait pour valider ce désabonnement.',
    'tooManySubscriptionRequests': 'Trop de demandes d\'abonnement ont été fait pour cet utilisateur.',
    'tooManyUnsubscriptionRequests': 'Trop de demandes de désabonnement ont été fait pour cet utilisateur.',
    'unsubscribe': 'Se désabonner',
    'unsubscriptionCompletedSuccessfully': 'Désinscription terminée avec succès!',
    'unsubscriptionDescription': 'Je comprends et j’accepte qu’à partir du moment ou j’aurai complété ma désinscription, je ne pourrai plus recevoir d’information importante et urgente de la part de ma municipalité suivie. Afin de recevoir des alertes ultérieurement, je devrai m’abonner à nouveau à ce service.',
  }
};

export default fr;
